import type { Signal } from "solid-js";
import { createSignal } from "solid-js";
import { makePersisted } from "@solid-primitives/storage";
import { parse, stringify } from "superjson";
import UserId from "./UserId";

const [welcomeModalUserIds, setWelcomeModalUserIds] = makePersisted<UserId[], Signal<UserId[]>>(
  // oxlint-disable-next-line solid/reactivity -- False-positive, 'makePersisted' retains reactivity
  createSignal<UserId[]>([]),
  {
    name: "moreapp_show_welcome_modal",
    storage: localStorage,
    serialize: (value) => stringify(value),
    deserialize: (value) => {
      const userIds: unknown = parse(value);
      return Array.isArray(userIds) ? userIds.filter((userId) => userId instanceof UserId) : [];
    },
  },
);

export const showWelcomeModal = (userId: UserId) => welcomeModalUserIds().some((id) => userId.equals(id));

export const setShowWelcomeModal = (userId: UserId) =>
  setWelcomeModalUserIds((ids) => (ids.some((id) => userId.equals(id)) ? ids : [...ids, userId]));

export const dismissWelcomeModal = (userId: UserId) =>
  setWelcomeModalUserIds((ids) => ids.filter((id) => !userId.equals(id)));
